import { create } from "zustand";
import type { PublicUserDto } from "@gryzonie/shared";

interface AuthState {
  accessToken: string | null;
  user: PublicUserDto | null;
  ready: boolean;
  setSession: (token: string, user: PublicUserDto) => void;
  clear: () => void;
  setReady: (ready: boolean) => void;
}

/**
 * Access token + user are kept in memory only. Refresh token lives in an
 * httpOnly cookie set by the API.
 */
export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  ready: false,
  setSession: (accessToken, user) => set({ accessToken, user }),
  clear: () => set({ accessToken: null, user: null }),
  setReady: (ready) => set({ ready }),
}));
